<template>
  <b-container>
    <b-col>
      <h1>CRITICAL MISS: 404 Page Not Found</h1>
    </b-col>
  </b-container>
</template>

<script>
export default {
  name: "",
  data: function() {
    return {};
  }
};
</script>
